import Alpine from "alpinejs";

interface InputList {
	values: Array<string>;
	suggested: Array<string>;
	unusedSuggestions: Array<string>;
	init: CallableFunction;
	handlePushValue: CallableFunction;
	handleRemoveValue: CallableFunction;
	handlePushSuggested: CallableFunction;
}

const inputList = (
	values: Array<string>,
	suggested: Array<string>,
): InputList => {
	return {
		values,
		suggested,
		unusedSuggestions: [],
		init(): void {
			this.unusedSuggestions = this.suggested.filter(
				(element) => !this.values.includes(element),
			);
			Alpine.watch(
				() => this.values,
				(value: string) => {
					const event = new Event("change");
					this.$refs.realInput.value = JSON.stringify(value);
					this.$refs.realInput.dispatchEvent(event);
				},
			);
		},

		handlePushValue(value: string): void {
			if (value) {
				this.values.push(value);
				this.$refs.input.value = "";
			}
		},

		handleRemoveValue(value: string): void {
			if (
				this.suggested.includes(value) &&
				!this.unusedSuggestions.includes(value)
			) {
				this.unusedSuggestions.push(value);
			}
			this.values.splice(this.values.indexOf(value), 1);
		},

		handlePushSuggested(value: string): void {
			this.unusedSuggestions.splice(this.unusedSuggestions.indexOf(value), 1);
			this.handlePushValue(value);
		},
	};
};

Alpine.data("inputList", inputList);
